import {BaseComponentPlus} from "react-vextensions";
import {TextInput, TextInputProps} from "react-vcomponents";
import React from "react";

export const TagsInput = (props: {value: string[], onChange: (val: string[])=>any} & Omit<TextInputProps, "value" | "onChange">)=>{
	const {enabled, value, onChange, ...rest} = props;
	return (
		<TextInput {...rest} enabled={enabled} style={{width: "100%"}}
			value={(value || []).join(", ")} onChange={val=>onChange(val.split(",").map(a=>a.trim()).filter(a=>a))}/>
	);
};